// Email validation
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Phone validation (international format)
export const validatePhone = (phone: string): boolean => {
  // Remove all non-numeric characters except + at the beginning
  const cleaned = phone.replace(/[^\d+]/g, '');
  
  // Check if it's a valid phone number format
  // Allows formats like: +1234567890, 1234567890, +44-123-456-7890
  const phoneRegex = /^(\+?\d{1,4})?[\s.-]?\(?\d{1,4}\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}[\s.-]?\d{1,5}$/;
  return phoneRegex.test(cleaned) && cleaned.length >= 7 && cleaned.length <= 20;
};

// Price validation
export const validatePrice = (price: number): boolean => {
  return price > 0 && price < 1000000; // Max 1 million
};

// Quantity validation
export const validateQuantity = (quantity: number): boolean => {
  return Number.isInteger(quantity) && quantity > 0 && quantity <= 100;
};

// Name validation
export const validateName = (name: string): boolean => {
  return name.trim().length >= 2 && name.trim().length <= 100;
};

// Section/Block validation
export const validateSection = (section: string): boolean => {
  return section.trim().length >= 1 && section.trim().length <= 50;
};

// Row validation
export const validateRow = (row: string): boolean => {
  return row.trim().length >= 0 && row.trim().length <= 10;
};

// Seat validation
export const validateSeat = (seat: string): boolean => {
  return seat.trim().length >= 0 && seat.trim().length <= 20;
};

// Get error message for validation
export const getValidationError = (field: string, value: any): string | null => {
  switch (field) {
    case 'email':
      return !validateEmail(value) ? 'Please enter a valid email address' : null;
    case 'phone':
      return !validatePhone(value) ? 'Please enter a valid phone number' : null;
    case 'buyerName':
    case 'supplier':
      return !validateName(value) ? 'Name must be between 2 and 100 characters' : null;
    case 'salePrice':
    case 'purchasePrice':
      return !validatePrice(value) ? 'Price must be greater than 0' : null;
    case 'quantity':
      return !validateQuantity(value) ? 'Quantity must be between 1 and 100' : null;
    case 'section':
    case 'category':
    case 'block':
      return !validateSection(value) ? 'This field must be between 1 and 50 characters' : null;
    case 'row':
      return !validateRow(value) ? 'Row must be no more than 10 characters' : null;
    case 'seat':
      return !validateSeat(value) ? 'Seat must be no more than 20 characters' : null;
    default:
      return null;
  }
};